import { produce } from "immer";
import { useState } from "react";

export interface TrackingFile {
  trackingId: string;
  progress: number;
  failed: boolean;
  errorMessages?: string[];
  file: File;
}

export function useFileUploadState() {
  const [trackingFiles, setTrackingFiles] = useState<TrackingFile[]>([]);

  const loadingFiles = trackingFiles.filter(({ failed }) => !failed);
  const failedFiles = trackingFiles.filter(({ failed }) => failed);

  const handleFileUploadProgress = (trackingId: string, { loaded, total }: { loaded: number; total: number }) => {
    setTrackingFiles(
      produce((draft) => {
        const matchingItem = draft.find((upload) => upload.trackingId === trackingId);
        if (matchingItem) matchingItem.progress = Math.floor((loaded * 100) / total);
      })
    );
  };

  const handleFileUploadComplete = (trackingId: string) => {
    setTrackingFiles((prevState) => prevState.filter((file) => file.trackingId !== trackingId));
  };

  const handleFileUploadError = (trackingId: string) => {
    setTrackingFiles(
      produce((draft) => {
        const matchingItem = draft.find((upload) => upload.trackingId === trackingId);
        if (matchingItem) {
          matchingItem.failed = true;
          matchingItem.errorMessages = ["Failed to upload"];
          matchingItem.progress = 100;
        }
      })
    );
  };

  return {
    loadingFiles,
    failedFiles,
    trackingFiles,
    setTrackingFiles,
    handleFileUploadProgress,
    handleFileUploadComplete,
    handleFileUploadError,
  };
}
